import IconApps from '@material-ui/icons/Apps';

import { SOCIAL_CHANNEL, NATIVE_CHANNEL, REVIEWS_CHANNEL, WEBSITE_CHANNEL } from 'src/data/channel';
import IconPlatformFacebook from 'src/assets/icons/PlatformFacebook';
import IconChannelFacebook from 'src/assets/icons/ChannelFacebook';
import IconPlatformLinkedin from 'src/assets/icons/PlatformLinkedin';
import IconPlatformYoutube from 'src/assets/icons/PlatformYoutube';
import IconChannelTwitter from 'src/assets/icons/ChannelTwitter';
import IconChannelInstagram from 'src/assets/icons/ChannelInstagram';
import IconChannelGoogle from 'src/assets/icons/ChannelGoogle';
import IconChannelTaboola from 'src/assets/icons/ChannelTaboola';
import IconChannelOutbrain from 'src/assets/icons/ChannelOutbrain';
import IconChannelRevcontent from 'src/assets/icons/ChannelRevcontent';
import IconChannelVerizon from 'src/assets/icons/ChannelVerizon';
import { ChannelPinterest } from 'src/assets/icons/ChannelPinterest';
import { NewChannelLinkedin } from 'src/assets/icons/NewChannelLinkedin';
import { MetaIcon } from 'src/assets/icons/ChannelMeta';
import { TrustpilotIcon } from 'src/assets/icons/ChannelTrustpilot';
import { AmazonIcon } from 'src/assets/icons/ChannelAmazon';
import { G2Icon } from 'src/assets/icons/ChannelG2';
import { ChannelLandingPagesIcon } from 'src/assets/icons/ChannelLandingPages';
import { ChannelHomepageIcon } from 'src/assets/icons/ChannelHomepage';

export function pickChannelIcon(channel, rounded, meta) {
  if (channel === SOCIAL_CHANNEL.facebook) {
    return meta ? MetaIcon : rounded ? IconChannelFacebook : IconPlatformFacebook;
  }
  if (channel === SOCIAL_CHANNEL.instagram) {
    return IconChannelInstagram;
  }
  if (channel === SOCIAL_CHANNEL.linkedin) {
    return rounded || meta ? NewChannelLinkedin : IconPlatformLinkedin;
  }
  if (channel === SOCIAL_CHANNEL.twitter) {
    return IconChannelTwitter;
  }
  if (channel === SOCIAL_CHANNEL.google) {
    return IconChannelGoogle;
  }
  if (channel === SOCIAL_CHANNEL.youtube) {
    return IconPlatformYoutube;
  }
  if (channel === SOCIAL_CHANNEL.pinterest) {
    return ChannelPinterest;
  }

  if (channel === NATIVE_CHANNEL.taboola) {
    return IconChannelTaboola;
  }
  if (channel === NATIVE_CHANNEL.outbrain) {
    return IconChannelOutbrain;
  }
  if (channel === NATIVE_CHANNEL.revcontent) {
    return IconChannelRevcontent;
  }
  if (channel === NATIVE_CHANNEL.verizon) {
    return IconChannelVerizon;
  }
  if (channel === REVIEWS_CHANNEL.trustpilot) {
    return TrustpilotIcon;
  }
  if (channel === REVIEWS_CHANNEL.amazon) {
    return AmazonIcon;
  }
  if (channel === REVIEWS_CHANNEL.g2) {
    return G2Icon;
  }
  if (channel === WEBSITE_CHANNEL.homepage) {
    return ChannelHomepageIcon;
  }
  if (channel === WEBSITE_CHANNEL.landingPages) {
    return ChannelLandingPagesIcon;
  }

  return IconApps;
}
